import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.css']
})
export class SelectAutocompleteComponent implements OnInit {
	myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  @Input('options') options: any[] =[];
  @Input('title') title: string;
  @Input('value') value: any;  
  nowValue: any;  
  @Output('selected') optionSelected = new EventEmitter()
  @Input('disabled') disabled 
  constructor() { }

  ngOnInit() {
	  this.filteredOptions = this.myControl.valueChanges.pipe(
	    startWith(''),
	    map(value => this._filter(value))
	  );
	  if (this.disabled== true) {
	  	this.myControl.disable()
	  }
	  
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.options!= undefined) {
			for (var i = 0; i < this.options.length; i++) {
	    	if (this.options[i].id== this.value) {
	    		this.nowValue = { id: this.value, text:this.options[i].text }
	    		break;
	    	}
	    }
	    if (this.options.length==0) {
	    	this.nowValue = { id: 0, text:''}
	    }
		}
		if (this.disabled== true) {
			this.myControl.disable()
		} else {
			this.myControl.enable()
		}
	}


	displayFn(item){
		return item ? item.text : item;
	}

	private _filter(value) {		
		if (value!= undefined&& typeof value == "string") {
			const filterValue = value.toLowerCase();
			if (this.options!=undefined) {
				return this.options.filter(option => option.text? (option.text.toLowerCase().indexOf(filterValue) === 0) :null);
			}	
		}
		else{
			return this.options;
		}

	}

	selected(e){
		this.optionSelected.emit(e.option.value)
	}

}
